import { cubicInOut } from 'svelte/easing';
import { tweened } from 'svelte/motion';
import { get } from 'svelte/store';

export type ItemProps = {
	position: {
		x: number;
		y: number;
	};
	size: {
		width: number;
		height: number;
	};
	in?: {
		x?: number;
		y?: number;
		scale?: number;
	};
	out?: {
		x?: number;
		y?: number;
		scale?: number;
	};
};

const tweenProps = {
	duration: 800,
	easing: cubicInOut
};

const transitionProps = {
	duration: 800,
	easing: cubicInOut
};

export class OvalItem {
	public destroyed = false;
	public isDestroying = false;

	public size = tweened(
		{
			width: 0,
			height: 0
		},
		tweenProps
	);
	public position = tweened(
		{
			x: 0,
			y: 0
		},
		tweenProps
	);
	public transform = tweened(
		{
			x: 0,
			y: 0,
			scale: 1
		},
		transitionProps
	);

	public color = '#000000';

	private out?: {
		x: number;
		y: number;
		scale: number;
	};

	constructor(props: ItemProps) {
		this.size.set(props.size, { duration: 0 });
		this.position.set(props.position, { duration: 0 });

		if (props.in) {
			this.transform.set(
				{
					x: props.in.x ?? 0,
					y: props.in.y ?? 0,
					scale: props.in.scale ?? 1
				},
				{ duration: 0 }
			);

			this.transform.set(
				{
					x: 0,
					y: 0,
					scale: 1
				},
				{
					...transitionProps,
					delay: 0
				}
			);
		}

		// if (props.out) {
		// 	this.out = {
		// 		x: props.out.x ?? 0,
		// 		y: props.out.y ?? 0,
		// 		scale: props.out.scale ?? 1
		// 	};
		// }
	}

	public render = (
		ctx?: CanvasRenderingContext2D,
		canvas?: {
			width: number;
			height: number;
		}
	) => {
		if (!ctx || !canvas) return;

		const position = get(this.position);
		const size = get(this.size);
		const transform = get(this.transform);

		const width = size.width * canvas.width;
		const height = size.height * canvas.height;
		const x = position.x * canvas.width + width * transform.x;
		const y = position.y * canvas.height + height * transform.y;

		ctx.moveTo(x + width * 0.5, y + height * 0.5);
		ctx.ellipse(
			x + width * 0.5,
			y + height * 0.5,
			width * 0.5 * transform.scale,
			height * 0.5 * transform.scale,
			0,
			0,
			Math.PI * 2
		);
	};

	public destroy = async () => {
		this.isDestroying = true;
		if (this.out) await this.transform.set(this.out);
		this.destroyed = true;
	};
}
